import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Building2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (!result.success) {
      toast.error(result.error);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex">
      {/* Left Brand Panel */}
      <div className="hidden lg:flex lg:flex-1 relative overflow-hidden">
        <span aria-hidden="true" className="pointer-events-none absolute inset-0"
              style={{ background: 'linear-gradient(150deg,#38BDF8 0%,#2563EB 38%,#6366F1 68%,#8B5CF6 100%)', backgroundSize: '220% 220%' }} />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white w-full">
          <div>
            <div className="inline-flex items-center gap-3 bg-white/95 backdrop-blur-sm px-4 py-3 rounded-2xl mb-8 shadow-xl">
              <img src="/assets/aampl-logo.jpg" alt="ANMOL" className="w-10 h-10 object-contain"
                   onError={(e) => { e.currentTarget.style.display = 'none'; }} />
              <span className="font-display text-2xl sm:text-3xl font-extrabold tracking-[-0.03em] text-[#172554]">AAMPL</span>
            </div>
            <h1 className="font-display text-[44px] font-extrabold leading-[1.06] mb-4 tracking-[-0.035em]">
              People operations,<br />beautifully managed.
            </h1>
            <p className="text-lg text-white/80 mb-12">
              Streamline HR workflows, track performance, and empower your team with intelligent insights.
            </p>
          </div>
        </div>
        
        {/* Decorative circles */}
      </div>

      {/* Right Form Panel */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-8 app-shell">
        <div className="w-full max-w-md glass-card reveal p-7 sm:p-10">
          <div className="mb-8">
            <h2 className="font-display text-[32px] font-extrabold mb-2 tracking-[-0.03em] grad-text">Welcome back</h2>
            <p className="text-sm text-[#5A6377]">Enter your credentials to access the HR portal</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] mb-2 block">Email Address</Label>
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=""
                className="h-11"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#64748B] mb-2 block">Password</Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=""
                className="h-11"
                required
              />
            </div>

            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              size="lg"
              className="w-full h-11"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
